<template>
    <div v-if="customer.stored_in_erp == false && this.render">
      <h4>Associer un client au contrat</h4>
      <p>
        Dans le cas ou c’est un prospect qui a créé son contrat en ligne, vous pouvez vérifier ici s’il n’existe déjà pas dans la base de données des clients validés, et donc déjà présent dans SAP. Après avoir comparer la liste des clients avec le prospect,
        vous pouvez décider de créer un nouveau client avec les informations du prospect déjà saisies ou de sélectionner un client existant et de lui attribuer le nouveau contrat.
      </p>
      <div class="row">
        <div class="col-md-12">
          <modal v-if="showModal" @confirm="attachAndReload()" @cancel="unToggleModal" :customer="this.selected_customer"></modal>
          <div v-if="customer" @select-customer="$emit('update-candidate', $event)" class="search_candidate">
              <label for="search_place" class="search_label"><span>Saisissez un mot pour rechercher un client existant</span></label>
              <input name="search_place" class="form-control tip w150" type="textarea" v-model="search"
              data-original-title="Recherche" data-placement="bottom" data-toggle="tooltip"
              placeholder="Recherche"
              >
              <button class="btn btn-success" v-if="search.length >= 3" @click="updateCandidate()">
                <i class="fa fa-search"></i>
                <span>Rechercher</span>
              </button>
              <span v-else style="display: inline-block; margin: 7px;">3 caractères minimum</span>
          </div>
          <hr>
          <div v-if="this.get_candidates.length">
            <label>Sélectionnez un client parmis les résultats ci dessous</label>
            <div class="candidates_container">
              <ul>
                <li >
                  <div class="customer_container_item">
                    <div class="at_left">
                      <input type="radio" @click="toggleModal(candidate)" :id="default_customer.id" :value="default_customer.name" v-model="selected_customer_id" ></input>
                    </div>
                    <div class="at_center">
                      <p>
                        <strong>{{default_customer.name}}</strong>
                        <em>{{ candidateIdentityMainRepresentative(default_customer.main_representative)}} </em>
                      </p>
                    </div>
                    <div class="at_right pull-right">
                      <router-link :to="{ name: 'customer', params: { id: default_customer.id } }" class="">
                        <i class="fa fa-plus"></i>
                        <span > Détails </span>
                      </router-link>
                    </div>
                  </div>
                </li>
                <li v-for="(candidate, idx) in sortedCandidates" class="customer_container_item">
                  <div class="customer_container_item">
                    <div class="at_left">
                      <input type="radio" @click="toggleModal(candidate)" :id="candidate.id" :value="candidate.name" v-model="selected_customer_id" ></input>
                    </div>
                    <div class="at_right">
                      <p>
                        <strong>{{candidate.name}}</strong>
                        <em>{{ candidateIdentityMainRepresentative(candidate.main_representative)}}</em>
                      </p>
                    </div>
                    <div class="at_right pull-right">
                      <router-link :to="{ name: 'customer', params: { id: candidate.id } }" >
                        <i class="fa fa-plus"></i>
                        <span > Détails </span>
                      </router-link>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <!-- <select2 class="full-width" :options="this.get_candidates" @input="updateSelectedCustomer($event)"></select2> -->
          </div>

          <div v-else>
            <p>Aucun résultat correspondant.</p>
          </div>
          <!-- <div v-if="current_selected_customer != null">
            <button class="btn btn-complete btn-cons" @click="showModal = true">
              Lier ce contrat au client sélectionné
            </button>
            <br>
          </div> -->
        </div>
        <!-- <div class="col-md-6" v-if="current_selected_customer == null" >
          <div>
            <router-link tag="button" class="btn btn-complete btn-cons" :to="{ name: 'create-prospects' }" style="margin-top: 104px;">
              Créer un nouveau client
            </router-link>
          </div>
        </div> -->
      </div>
    </div>
    <div v-else-if="readyTorender && full_actualcustomer" class="already_attached_customer_container">
      <div class="centered_container" >
        <!-- <div class="old_customer">
          <h5>Anciennement</h5>
          <customer :customer="full_initialcustomer" :enable_details="false">
          </customer>
        </div> -->
        <div class="new_customer">
          <customer :customer="full_actualcustomer" :enable_details="false">
            <span class="title_suffix" slot="title_suffix"> (Actuellement attaché)</span>
          </customer>
        </div>
      </div>
    </div>
</template>
<script>
import {mapActions, mapState, mapGetters} from 'vuex'
import Customer from 'components/Demands/Details/ValidationRequestable/Customer'
import Select2 from 'components/Form/Select2'
import Modal from "./Modals/Step2Modal"

export default {
    name:"Step2",

    components:{
      Select2,
      Modal,
      Customer,
    },

    computed:{
        ...mapState('demands', ['candidates', 'forms', 'current_treating_demand']),
        ...mapGetters('demands', ['get_candidates']),

        customer () {
          var tf = _.find(this.forms, (form) => form.main_request.request.id == this.$route.params.id)
          if (tf && tf.main_request && tf.main_request.related_models && tf.main_request.related_models.customer)
            return { name: tf.main_request.related_models.customer.name, stored_in_erp: tf.main_request.related_models.customer.stored_in_erp, id: tf.main_request.related_models.customer.id }
          return false
        },

        full_actualcustomer () {
          var tf = _.find(this.forms, (form) => form.main_request.request.id == this.$route.params.id)
          if (tf && tf.main_request && tf.main_request.related_models && tf.main_request.related_models.customer)
            return tf.main_request.related_models.customer
          return false
        },

        full_initialcustomer () {
          if (this.current_treating_demand && this.current_treating_demand.demand && this.current_treating_demand.demand.customer)
            return this.current_treating_demand.demand.customer
          return false
        },

        order_id () {
          var tf = _.find(this.forms, (form) => form.main_request.request.id == this.$route.params.id)
          if (tf && tf.main_request && tf.main_request.model_new_version && tf.main_request.model_new_version.order)
            return tf.main_request.model_new_version.order.id
          return false
        },


        get_customer(){
          return this.customer.name
        },

        get_current_selected(){
          return _.find(this.get_candidates, candidate => candidate.name === this.selected_customer_id)
        },

        sortedCandidates() {
          return  _.filter(this.get_candidates, candidate => {
            return candidate.id != this.customer.id && candidate.stored_in_erp == true
          })
        },

        readyTorender() {
          return this.render
        }
    },

    methods:{
      ...mapActions('demands', ['getCandidates', 'cleanCandidates', 'attachSAPCustomer']),

      candidateIdentityMainRepresentative(candidate) {
        if (candidate)
          return candidate.decoded_representative_quality + ' ' + candidate.decoded_civility + ' ' + candidate.first_name + ' ' + candidate.last_name
        return "Données manquantes"
      },

      updateCandidate() {
        this.cleanCandidates()
        if (this.search)
          this.getCandidates({search:this.search, validated:1})
      },

      updateSelectedCustomer(event) {
        if (event)
          {
            this.current_selected_customer = event
            this.$forceUpdate()
          }
      },

      attachAndReload() {
        if (this.get_current_selected)
          {
            this.attachSAPCustomer({order_id:this.order_id, sap_customer:Number(this.get_current_selected.id)})
                .then(() => {
                  location.reload()
                })
          }
        },

        toggleModal(customer){
          this.selected_customer = customer
          this.showModal = true
        },

        unToggleModal(customer){
          this.selected_customer = null
          this.selected_customer_id = this.customer.name
          this.showModal = false
        },

        init() {

        }
    },

    data(){
      return {
        search:null,

        selected_customer_id:null,
        default_customer:null,

        render:false,
        showModal:false,
        demand_id:this.$route.params.id,
      }
    },

    watch : {
      customer : function () {

      },

      candidates : function (newv, oldv) {
        if ((this.default_customer == null || this.default_customer == undefined) && this.customer)
          this.default_customer = _.find(newv, candidate => candidate.id == this.customer.id)
      },

      search : function () {
          if (this.render == false)
            if (this.search && this.search.length)
              this.getCandidates({search:this.search, validated:1})
                .then(() =>
                {
                  this.default_customer = _.find(this.candidates, candidate => candidate.id == this.customer.id)
                  this.selected_customer_id = this.customer.name
                  this.render = true
                })
      }
    },

    created() {
      this.search = this.get_customer
    },


}

</script>
<style scoped>
.customer_container_item {
  display: -webkit-box;
  width: inherit;
  display: block;
}

.candidates_container {
  height:420px;
  overflow: auto;
}

.search_candidate {
  display: -webkit-inline-box;
}

.search_label {
  margin-top: 7px;
  margin-right: 5px;
}

ul {
    padding: 0;
    margin: 0;
    -webkit-column-count: 2;
       -moz-column-count: 2;
            column-count: 2;
    -webkit-column-width: 50%;
       -moz-column-width: 50%;
            column-width: 50%;

}

ul li {
  line-height: 48px;
}
.to_right {
    margin-left: auto;
}

.at_left {
  display: inline-block;
}

.at_center {
  display: inline-block;
}

.at_right {
  display: inline-block;
}

.already_attached_customer_container {

}

.centered_container {
  display: flex;
}

.old_customer, .new_customer {
  margin-left:auto;
  margin-right: auto;
}

.old_customer > h5, .new_customer > h5 {
    text-align: center;
}

.title_suffix {

}

</style>



// WEBPACK FOOTER //
// client/components/Demands/Step2.vue